<template>
    <div class="page-wrapper point-collection-page" v-if="isLoaded">
        <div class="page-bg"></div>
        <div class="page-content">
            <TopBar
                :isGray="true">
            </TopBar>
            <div class="wrapper-main-point">
                <div class="img-logo-naos">
                    <img :src="$store.getters.getLogoNao" alt="">
                </div>

                <div class="text-point">
                    {{lbl.qrcode.main_point_collection.text_scan}}<br/>
                    <span class="collect">{{lbl.qrcode.main_point_collection.text_collect}}</span>
                    <span class="point">{{lbl.qrcode.main_point_collection.text_point}}</span>
                </div>
            </div>
            <div class="img-product">
                <img :src="$store.getters.getImageProduct" class="img_fluid">
            </div>
            <div class="btn-scan" @click="clickScanQr()">
                <div class="btn-txt">
                {{lbl.qrcode.main_point_collection.btn_scan_qr}}
                </div>
            </div>
            <div class="btn_view" @click="clickViewProduct()">
                {{lbl.qrcode.main_point_collection.btn_point_product}}
            </div>

        </div>
        <ModalMaster :controller="modalController" />
        <FooterMenu
            currentMenu="point"
            :controller="modalController">
        </FooterMenu>
    </div>
</template>
<script>
// import Util from "@/helper/Utility.js";
import CacheHelper from "@/helper/CacheHelper.js";
import { TrackingService } from "@/helper/TrackingHelper.js";
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";

//component
import TopBar from "@/components/Layout/TopBar/TopBar.vue";
import FooterMenu from "@/components/Layout/FooterMenu/FooterMenu.vue";

export default {
    name: "Login",
    mixins: [AccountMixin, LocaleMixin, ModalMixin, ErrorApiMixin],
    components: {
        TopBar,
        FooterMenu
    },
    data: function() {
        return {
            isLoaded: false,
            errorInfo: [],
            isFormValid: false,
            contactNumber: '',

            serialCode: '',
            cache: new CacheHelper('session'),
            tracking: new TrackingService(this)
        };
    },
    methods: {
        accountInitiated: function () {
            this.isLoaded = true;

            // setTimeout(() =>{
            //     this.loadingModal.show();
            // },0);

            this.getCode();
            this.tracking.screenName('Collect_Point_Page');
        },
        // call by mixin modal
        // setupModalCompleted: function() {
        //     this.initialProductDescriptionModal();
        //     this.initialPointSummaryModal();
        //     this.initialOtherModal();

        //     this.getCode();
        // },
        getCode: function(){
            // setTimeout(() =>{
            //     this.loadingModal.hide();
            // },300)

            if(this.cache.getCache('BDMCode')){
                this.serialCode = this.cache.getCache('BDMCode');

                console.log(this.pointCollectionModal);

                setTimeout(() =>{
                    this.pointCollectionModal
                        .setCode(this.serialCode)
                        .show();
                },300);
            }else if(this.cache.getCache('BDMScan')){
                setTimeout(() =>{
                    this.cache.removeCache('BDMScan');
                    this.pointCollectionModal.show();
                },300);
            }
        },
        //event
        clickScanQr: function() {
            //this.$router.push('/qrcode');
            this.tracking.event('collect_point', 'click_collect_point');
            this.pointCollectionModal.show();
            this.pointCollectionModal.onClickOk((data) => {
                if (data) {
                    this.tracking.event('confirm_serial_code', 'click_confirm_serial_code');
                }
            });
        },
        clickViewProduct: function() {
            this.$router.push('/point/guide');
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";
@import '@/style/input/BaseButton.scss';
@import "../style/PointCollection.scss";
</style>
